




























import Vue from "vue";

interface ComponentState {
  tab: string,
}

// noinspection JSUnusedGlobalSymbols
export default Vue.extend({
  components: {
    VInventoryInstruments: () => import("@/components/inventoryComponents/VInventoryInstruments.vue"),
    VInventoryBows: () => import("@/components/inventoryComponents/bows/VInventoryBows.vue"),
    VInventoryStrings: () => import("@/components/inventoryComponents/strings/VInventoryStrings.vue"),
    VInventoryOther: () => import("@/components/inventoryComponents/other/VInventoryOther.vue")
  },
  name: "Inventory",
  data(): ComponentState {
    return {
      tab: "v-inventory-instruments"
    };
  }
});
